import type { performViatorProductSearch } from "@/lib/requests/ads/viator";
import type { SectionType } from "@/lib/requests/getItineraryDays";
import { useEffect, useState } from "react";
import { DestinationDayPlans } from "./LocationRecipe";

export function DestinationDayPlansWithClientViator({
  lat,
  lng,
  country,
  city,
  days,
}: {
  lat: string;
  lng: string;
  country: string;
  city?: string;
  days: SectionType;
}) {
  const [viatorData, setViatorData] = useState<{
    products: Awaited<ReturnType<typeof performViatorProductSearch>>;
  }>({
    products: [],
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchViatorData = async () => {
      try {
        if (!lat || !lng) {
          setIsLoading(false);
          return;
        }

        const params = new URLSearchParams({
          lat,
          lng,
        });

        // Add city and country if available
        if (city) params.append("city", city);
        if (country) params.append("country", country);

        const url = `/api/viator-products.json?${params.toString()}`;

        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch Viator data: ${response.status}`);
        }

        const data = await response.json();
        setViatorData(data);
      } catch (error) {
        console.error("Error fetching Viator data:", error);
        setViatorData({ products: [] });
      } finally {
        setIsLoading(false);
      }
    };

    fetchViatorData();
  }, [lat, lng, city, country]);

  return (
    <DestinationDayPlans
      country={country}
      city={city}
      days={days}
      viator={viatorData}
      lat={lat}
      lng={lng}
      isViatorLoading={isLoading}
    />
  );
}
